import React from "react";

export default function Map() {
  return (
    <iframe
      title="avaxia-map"
      className="map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.8324138289963!2d10.190549576522708!3d36.82253556643885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd3579ac733627%3A0xbd65fbc4e1f248ff!2sAvaxia%20group!5e0!3m2!1sen!2stn!4v1726743915673!5m2!1sen!2stn"
      width="100%"
      height={724}
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}